/**
 * Legal Module Initializer
 * Manages legal form selection and subcategory text
 */

import { AbortControllerManager } from '/modules/ui/abort-controller-manager.js';
import { APIClient } from '/modules/services/api-client.js';
import { LegalController } from '/modules/features/legal/legal-controller.js';
import { LegalValidator } from '/modules/features/legal/legal-validator.js';

// Configuration
const config = {
    legalFormsSelector: '[data-lega-forms]',
    subcategoryTextSelector: '[data-subcategory-text]'
};

// Initialize core services
const abortManager = new AbortControllerManager();
const apiClient = new APIClient(abortManager);

// Initialize feature controllers
const legalController = new LegalController(apiClient, config);
const legalValidator = new LegalValidator(config);

// Export instances for use in other modules if needed
export {
    abortManager,
    apiClient,
    legalController,
    legalValidator,
    config
};

// Create global wrapper function for backward compatibility
window.saveTabLegal = function() {
    return legalController.save();
};

// Initialize on DOM ready
$(document).ready(() => {
    console.log('🚀 Legal module initialized');
    
    // Check if tabLegalForm exists (only for "Vie des sociétés" category)
    const tabLegalFormExists = $('#tabLegalForm').length > 0;
    
    if (!tabLegalFormExists) {
        console.log('ℹ️ Legal tab not present, skipping legal validator initialization');

        window.dispatchEvent(new CustomEvent('module-loaded', { 
            detail: { moduleName: 'legal-module' }
        }));
        return;
    }
    
    // Register tasks with userInterface
    legalController.registerTasks();
    
    // Trigger initial update
    if (typeof userInterface !== 'undefined' && userInterface.update) {
        userInterface.update({
            skipReference: true,
            skipMainForm: true,
            skipIdTab: true
        });
    }
    
    // Initialize validator only if legal tab exists
    legalValidator.init();
    
    console.log('✅ Legal module ready');
    
    // Notify module loader via event (auto-registration)
    window.dispatchEvent(new CustomEvent('module-loaded', { 
        detail: { moduleName: 'legal-module' }
    }));
});

// Expose module for debugging in console
if (typeof window !== 'undefined') {
    window.LegalModule = {
        controller: legalController,
        validator: legalValidator,
        apiClient,
        abortManager,
        config
    };
    console.log('🔧 LegalModule available in window for debugging');
}
